export default "__VITE_ASSET__D$qZESpR__"